import { Component, Input, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ConnectEcmService } from 'app/connect/core/connect-ecm.service';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { UtilsService } from 'app/environment/services/utils.service';
import { NgForm } from '@angular/forms';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { IConnectRepository } from 'app/connect/core/IConnectRepository';
import { ConnectEcmFoldersComponent } from '../connect-ecm-folders/connect-ecm-folders.component';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'connect-ecm-properties',
    templateUrl: 'connect-ecm-properties.component.html',
    styleUrls: ['connect-ecm-properties.component.scss']

})
export class ConnectEcmPropertiesComponent {

    @ViewChild('propertiesForm', { static: false}) propertiesForm: NgForm;    
    @Input() selectedRepository: IConnectRepository;
    @Input() metadata;
    @Input() reloadFolders: () => void; // Define la propiedad de entrada para recibir la función
    public repositories: any;
    public showLoading: boolean;
    public isConnectedToRepositories: boolean;
    public initialExternalRepositoryId: string;

    constructor(private _connectEcmService: ConnectEcmService,
        private _encryptService: CryptoDataService,
        private ref: ChangeDetectorRef,
        public utilsService: UtilsService,
        private _translateService: TranslateService,
        private _toastService: BzgToastService,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.repositories = null;
        this.isConnectedToRepositories = false;
        this.initialExternalRepositoryId = this.selectedRepository.environment.params.externalId;
        this.ref.detectChanges();
    }

    async connectToRepositories() {
        this.showLoading = true;
        if (this.isValid()) {
            this.selectedRepository.environment.params.password = (await this._encryptService.encryptString(
                this.selectedRepository.environment.params.password).toPromise()).encryptedPassword;
            this.repositories = await this._connectEcmService.connectToRepositories(
                this.selectedRepository.environment.params).toPromise().catch(() => {
                    this.showLoading = false;
                });

            if (this.repositories) {
                this.reloadFolders(); // Llama a reloadFolders después de conectar a los repositorios
                this.isConnectedToRepositories = true;
                this._showToastService.showToast(this._i18nService.instant('ECM.CONNECTION_OK'), 'success');
            } else {
                this.isConnectedToRepositories = false;
                this._showToastService.showToast(this._i18nService.instant('ECM.CONNECTION_FAILED'), 'error');
            }
        }
        this.showLoading = false;
    }

    selectRepository(repository, checked) {
        if (checked) {
            this.selectedRepository.environment.params.externalId = repository.Id;
            this.selectedRepository.environment.params.repositoryName = repository.Value;
        }
    }

    public isValid(): boolean {
        if (this.propertiesForm) {
            this.propertiesForm.form.markAllAsTouched();
          }      
        return this.propertiesForm && this.propertiesForm.valid;
    }
}
